import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import loadGif from "../../../../assets/images/loading.gif";
import { useState } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { connect } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";

import { useNavigate } from "react-router-dom";
import { AddNewPlayer } from "../../../../api/AuthenticationServices";
const imageConvert = require("../../../imageConvert");
const NewPlayer = (props) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const [aadhaarFile, setAadhaarFile] = useState(null);
  const [profileFile, setProfileFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleAadhaarFileChange = async (event) => {
    const base64 = await imageConvert(event.target.files[0]);
    setAadhaarFile(base64);
  };
  const handleProfileFileChange = async (event) => {
    const base64 = await imageConvert(event.target.files[0]);
    setProfileFile(base64);
  };
  const sendData = async (e, values) => {
    setLoading(true);
    console.log(values);
    e.preventDefault();

    const formData = new FormData();
    formData.append("aadhaarFile", aadhaarFile);
    formData.append("profileFile", profileFile);

    formData.append("plFirstName", values.plFirstName);
    formData.append("plLastName", values.plLastName);
    formData.append("plDob", values.plDob);
    formData.append("plAadhaar", values.plAadhaar);
    formData.append("plGender", values.plGender);
    formData.append("plAddress", values.plAddress);
    formData.append("plFatherName", values.plFatherName);
    formData.append("plMotherName", values.plMotherName);
    formData.append("plfatherPhnNumber", values.plfatherPhnNumber);
    formData.append("plmotherPhnNumber", values.plmotherPhnNumber);
    formData.append("plParentOfficeAddress", values.plParentOfficeAddress);
    formData.append("plSchoolName", values.plSchoolName);
    formData.append("plSchoolAddress", values.plSchoolAddress);
    formData.append("plClassStudy", values.plClassStudy);
    formData.append("plEmailId", values.plEmailId);
    formData.append("plDateOfJoining", values.plDateOfJoining);
    formData.append("plTransportMode", values.plTransportMode);

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + localStorage.getItem("authorizeToken"), // your authorization token here
      },
    };
    try {
      const res = await AddNewPlayer(formData, config);
      setLoading(false);
      if (res.data.status === "success") {
        // console.log("Inside Successs");
        alert(res.data.message);
        navigate("/admin/newplayer");
      }
    } catch (e) {
      setLoading(false);

      //FIX : Message of error need to be shown to user Only Axios Error Displaying
      alert(e);
    }
  };
  return (
    <div>
      <Box m="20px">
        <Header title="NEW PLAYER" subtitle="Create a New player" />

        <Formik
          // onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => (
            // console.log(values,handleChange)
            <form onSubmit={(e) => sendData(e, values)}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="First Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plFirstName}
                  name="plFirstName"
                  error={!!touched.plFirstName && !!errors.plFirstName}
                  helperText={touched.plFirstName && errors.plFirstName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Last Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plLastName}
                  name="plLastName"
                  error={!!touched.plLastName && !!errors.plLastName}
                  helperText={touched.plLastName && errors.plLastName}
                  sx={{ gridColumn: "span 2" }}
                />

                <TextField
                  fullWidth
                  variant="filled"
                  type="date"
                  label="Date of Birth"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plDob}
                  name="plDob"
                  error={!!touched.plDob && !!errors.plDob}
                  helperText={touched.plDob && errors.plDob}
                  sx={{ gridColumn: "span 4" }}
                />
                <InputLabel id="pl-gen" sx={{ gridColumn: "span 2" }}>
                  Select Gender
                </InputLabel>
                <Select
                  labelId="pl-gen"
                  fullWidth
                  variant="filled"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plGender}
                  name="plGender"
                  error={!!touched.plGender && !!errors.plGender}
                  helperText={touched.plGender && errors.plGender}
                  sx={{ gridColumn: "span 2" }}
                >
                  <MenuItem value="" disabled>
                    <em>Player Gender</em>
                  </MenuItem>
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                </Select>
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Player Email Id"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plEmailId}
                  name="plEmailId"
                  error={!!touched.plEmailId && !!errors.plEmailId}
                  helperText={touched.plEmailId && errors.plEmailId}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Address"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plAddress}
                  name="plAddress"
                  error={!!touched.plAddress && !!errors.plAddress}
                  helperText={touched.plAddress && errors.plAddress}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Father Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plFatherName}
                  name="plFatherName"
                  error={!!touched.plFatherName && !!errors.plFatherName}
                  helperText={touched.plFatherName && errors.plFatherName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Mother Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plMotherName}
                  name="plMotherName"
                  error={!!touched.plMotherName && !!errors.plMotherName}
                  helperText={touched.plMotherName && errors.plMotherName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Father Contact Number"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plfatherPhnNumber}
                  name="plfatherPhnNumber"
                  error={
                    !!touched.plfatherPhnNumber && !!errors.plfatherPhnNumber
                  }
                  helperText={
                    touched.plfatherPhnNumber && errors.plfatherPhnNumber
                  }
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Mother Contact Number"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plmotherPhnNumber}
                  name="plmotherPhnNumber"
                  error={
                    !!touched.plmotherPhnNumber && !!errors.plmotherPhnNumber
                  }
                  helperText={
                    touched.plmotherPhnNumber && errors.plmotherPhnNumber
                  }
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Office Address"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plParentOfficeAddress}
                  name="plParentOfficeAddress"
                  error={
                    !!touched.plParentOfficeAddress &&
                    !!errors.plParentOfficeAddress
                  }
                  helperText={
                    touched.plParentOfficeAddress &&
                    errors.plParentOfficeAddress
                  }
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="School Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plSchoolName}
                  name="plSchoolName"
                  error={!!touched.plSchoolName && !!errors.plSchoolName}
                  helperText={touched.plSchoolName && errors.plSchoolName}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="School Address"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plSchoolAddress}
                  name="plSchoolAddress"
                  error={!!touched.plSchoolAddress && !!errors.plSchoolAddress}
                  helperText={touched.plSchoolAddress && errors.plSchoolAddress}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Class Currently Studying"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plClassStudy}
                  name="plClassStudy"
                  error={!!touched.plClassStudy && !!errors.plClassStudy}
                  helperText={touched.plClassStudy && errors.plClassStudy}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="date"
                  label="Date of Joining"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plDateOfJoining}
                  name="plDateOfJoining"
                  error={!!touched.plDateOfJoining && !!errors.plDateOfJoining}
                  helperText={touched.plDateOfJoining && errors.plDateOfJoining}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Mode of Transport"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plTransportMode}
                  name="plTransportMode"
                  error={!!touched.plTransportMode && !!errors.plTransportMode}
                  helperText={touched.plTransportMode && errors.plTransportMode}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Aadhaar Number"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plAadhaar}
                  name="plAadhaar"
                  error={!!touched.plAadhaar && !!errors.plAadhaar}
                  helperText={touched.plAadhaar && errors.plAadhaar}
                  sx={{ gridColumn: "span 4" }}
                />
                <InputLabel id="pl-gen" sx={{ gridColumn: "span 2" }}>
                  Upload Aadhaar
                </InputLabel>
                <input type="file" onChange={handleAadhaarFileChange} />
                <InputLabel sx={{ gridColumn: "span 2" }}>
                  Upload Profile Photo
                </InputLabel>
                <input type="file" onChange={handleProfileFileChange} />
                {/* <InputLabel id="pl-siblings" sx={{ gridColumn: "span 2" }}>
                  Select If any Siblings
                </InputLabel>
                <Select
                  labelId="pl-siblings"
                  fullWidth
                  variant="filled"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plSiblings}
                  name="plSiblings"
                  error={!!touched.plSiblings && !!errors.plSiblings}
                  helperText={touched.plSiblings && errors.plSiblings}
                  sx={{ gridColumn: "span 2" }}
                >
                  <MenuItem value="" disabled>
                    <em>Player Siblings</em>
                  </MenuItem>
                  {mockSiblings.map(
                    function (sib, index) {
                      return (
                        <MenuItem key={index} value={sib.id}>
                          {sib.name}
                        </MenuItem>
                      );
                    },
                    [1]
                  )}
                </Select> */}
              </Box>
              {/* <button type="submit">asdasd</button> */}

              <div>
                {loading ? (
                  <div className="flex items-center justify-center">
                    <img
                      src={loadGif}
                      alt="Loading"
                      style={{ width: "70px", height: "70px" }}
                    />{" "}
                  </div>
                ) : (
                  <Box display="flex" justifyContent="end" mt="20px">
                    <Button
                      type="submit"
                      disabled={false}
                      color="secondary"
                      variant="contained"
                    >
                      Create New User
                    </Button>
                  </Box>
                )}
              </div>
            </form>
          )}
        </Formik>
      </Box>
    </div>
  );
};

const phoneRegExp =
  /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;

const checkoutSchema = yup.object().shape({
  plFirstName: yup.string().required("required"),
  plLastName: yup.string().required("required"),
  plDob: yup.string().required("required"),

  plGender: yup.string().required("required"),
  plemail: yup.string().email("invalid email").required("required"),
  plAddress: yup.string().required("required"),
  plAadhaar: yup.string().required("required"),
  plFatherName: yup.string().required("required"),
  plMotherName: yup.string().required("required"),
  plfatherPhnNumber: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("required"),
  plmotherPhnNumber: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("required"),
  plParentOfficeAddress: yup.string().required("required"),
  plSchoolName: yup.string().required("required"),
  plSchoolAddress: yup.string().required("required"),
  plClassStudy: yup.string().required("required"),
  plTransportMode: yup.string().required("required"),
  plDateOfJoining: yup.string().required("required"),
});
const initialValues = {
  plFirstName: "",
  plLastName: "",
  plDob: "",
  plAadhaar: "",
  plGender: "",
  plAddress: "",
  plFatherName: "",
  plMotherName: "",
  plfatherPhnNumber: "",
  plmotherPhnNumber: "",
  plParentOfficeAddress: "",
  plSchoolName: "",
  plSchoolAddress: "",
  plClassStudy: "",
  plEmailId: "",
  plDateOfJoining: "",
  plTransportMode: "",
};

function mapStateToProps(state) {
  return {
    loginToken: state.loginToken,
  };
}

export default connect(mapStateToProps)(NewPlayer);
